const lightTheme = {
  primary: '#1C274C',
  secondary: '#ADB9E1',
  background: '#ffffff',
  layoutBackground: '#F7F8FA',
  textPrimary: '#000000',
  textSecondary: '#666666'
};

const darkTheme = {
  primary: '#1C274C',
  secondary: '#ADB9E1',
  background: '#FFFFFF',
  layoutBackground: '#F7F8FA',
  textPrimary: '#000000',
  textSecondary: '#666666'
};

export const themes = {
  light: lightTheme,
  dark: darkTheme
};
